import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth/services/auth.service';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { RouterLoadingService } from './shared/services/router-loading.service';
import { DialogManagerService } from './shared/services/dialog-manager.service';
import { ModalContainerComponent } from './shared/components/modals/modal-container.component';
import { CartService } from './modules/products/services/cart.service';
import { ThemeService } from './shared/services/theme.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, LoadingComponent, ModalContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'WomensBesties';

  constructor(
    private authService: AuthService,
    private router: Router,
    private routerLoadingService: RouterLoadingService,
    private dialogManagerService: DialogManagerService,
    private cartService: CartService, // Inject to initialize cart on app load
    private themeService: ThemeService // Inject to initialize theme on app load
  ) {}

  ngOnInit(): void {
    // Ensure auth service is properly initialized
    
    this.authService.initializeFromStorage();

    // Always default to Pink theme on auth screens (login/logout/register)
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        if (event.urlAfterRedirects.startsWith('/auth')) {
          this.themeService.resetToDefault();
        }
      });
    
    // Cart service is automatically initialized via its constructor
    // It will load cart data if user is already logged in
    
    // Router loading service is automatically initialized via dependency injection
    // Dialog manager service is automatically initialized via dependency injection
  }
}
